var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loaded)?_c('div',[_vm._v("Loading playlist...")]):_c('ul',{staticClass:"track-list -no-bullets"},_vm._l((_vm.entries),function(entry){return _c("entry",{tag:"li",attrs:{"entry":entry,"type":entry.type,"playlist-id":_vm.id,"list-name":"activities-list"},on:{"ended":_vm.playerEnded}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }